import React  from 'react';
import YoutubePlaylistNativeEmbed from '../../../cmp/YoutubePlaylistNativeEmbed';

function YoutubePlaylistComponent({playlistId}) {
      return (
          <YoutubePlaylistNativeEmbed playlistId={playlistId}/>
      );
}

export default YoutubePlaylistComponent;
